export function replaceInputFiles(input, files) {
  const transfer = new window.DataTransfer()
  files.forEach(file => transfer.items.add(file))
  input.files = transfer.files
}

export function selectedFiles(activeInput, filesInput, folderInput) {
  if (activeInput) return Array.from(activeInput.files)
  if (filesInput.files.length > 0) return Array.from(filesInput.files)

  return Array.from(folderInput.files)
}

export function fileExtensionIsAccepted(filename, accept) {
  const acceptedExtensions = accept
    .split(",")
    .map(value => value.trim().toLowerCase())
    .filter(value => value.startsWith("."))
  if (acceptedExtensions.length === 0) return true

  const extension = filename.match(/\.[^./\\]+$/)?.[0].toLowerCase()
  return extension ? acceptedExtensions.includes(extension) : false
}

export function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`

  const units = [ "KB", "MB", "GB" ]
  let value = bytes / 1024
  let unit = units[0]

  for (let index = 1; value >= 1024 && index < units.length; index += 1) {
    value /= 1024
    unit = units[index]
  }

  const precision = value >= 10 ? 0 : 1
  return `${value.toFixed(precision)} ${unit}`
}

export function fileType(filename, fallback = "FILE") {
  const extension = filename.split(".").pop()?.toUpperCase()
  return extension && extension !== filename.toUpperCase() ? extension.slice(0, 4) : fallback
}

export function documentTitleFromFilename(filename) {
  const basename = filename.split(/[\\/]/).pop()
  const withoutExtension = basename.replace(/\.[^/.]+$/, "")
  const words = withoutExtension.replace(/[._-]+/g, " ").replace(/\s+/g, " ").trim()

  return words.charAt(0).toUpperCase() + words.slice(1)
}
